import { AppConfig } from "./../../app/app.config";
import { Component } from "@angular/core";
import {
  NavController,
  AlertController,
  ActionSheetController,
  Events,
  ModalController,
  NavParams,
  PopoverController,
  Platform,
} from "ionic-angular";
import { FormBuilder, Validators } from "@angular/forms";
import { StorageService } from "./../../providers/storage.service";
import { LoaddingService } from "./../../providers/loadding.service";
import { AlertService } from "./../../providers/alert.service";
import { SigninService } from "./../../services/signin.service";
import { SysconfigService } from "./../../services/sysconfig.service";
import { AgreeMsg, UserList } from "./agreemsg";
import { Realm } from "./realm";
import { SysconfigModel, AppInfo } from "../../models/user.model";
import * as $ from "jquery";
import * as uuid from "uuid";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { log } from "util";
import { ImService } from "../im/im.service";
import { SliderCaptchaPage } from "./slider-captcha/slider-captcha";
import { RechargeService } from "../../services/recharge.service";
import { slideBlockCommon } from "../slide-block/slideBlock";
import { LotteryService } from "../../services/lottery.service";

@Component({
  selector: "page-signin",
  templateUrl: "signin.html",
  providers: [SigninService, SysconfigService, LotteryService],
})
export class SigninPage {
  local: Storage;
  autourl = [];
  ping1 = 0;
  lastUser: UserList = new UserList();
  users: UserList[] = [];
  requestTime = new Date().getTime();
  downloadUrl = "";
  isShowQrCode: boolean = false;
  showZhongWen: boolean = false;
  /** 图片验证是否成功 */
  validateStatus: boolean;
  showCaptcha: boolean = false;
  // 验证码刷新定时器
  captchaTimer = null;
  registerUrl;
  registerTimer;
  wapUrl = [];
  // 判断注册是否开放
  isEnable: boolean = false;
  link = '';
  sum_count: number = 10; // 倒计时两分钟
  url = window.location.href;
  hostUrl = AppConfig.GetHostUrl();
  hijackingUrl: string;
  loginNeedSecurityImage: boolean = false;            // 登录是否显示滑块验证按钮
  loginSecurityImageResult: boolean = false;          // 登录滑块验证验证结果
  loginTextFlag: boolean = false;                     // 登录滑块验证按钮文字
  platformsArr;
  isAndroidWap: boolean;
  isAppScreen: boolean;
  downClick = false;
  isWap = AppConfig.isWap;
  constructor(
    public navCtrl: NavController,
    private formBuilder: FormBuilder,
    private loading: LoaddingService,
    private alert: AlertService,
    private config: AppConfig,
    private signinService: SigninService,
    private storage: StorageService,
    private sysconfig: SysconfigService,
    private lotteryService: LotteryService,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    public navParams: NavParams,
    private iab: InAppBrowser,
    private popoverCtrl: PopoverController,
    public platform: Platform,
  ) {
    // this.registerTimer = setInterval(()=>{
    //   this.registerTimer()
    // },5000)
    // localStorage.removeItem('lotterys');
    if (this.storage.readString("Users")) {
      const userArrStr = AppConfig.decodeBase64(
        this.storage.readString("Users")
      );
      if (userArrStr) {
        this.users = JSON.parse(userArrStr);
      }

      if (this.users != null && this.users.length > 0) {
        this.lastUser = this.users[0];
      }
    }
    // 判断只有Wap端显示立即注册按钮
    // if (this.hostUrl == "") {
    //   this.isWap = true;
    // } else {
    //   this.isWap = false;
    // }

    clearInterval(ImService.getMessageCount);
    this.platform.ready().then(() => {
      this.platformsArr = this.platform.platforms();
      console.log(this.platformsArr);

    })
    // this.isAndroidWap = window.matchMedia('(display-mode: standalone)').matches;
    if (window.hasOwnProperty("AndroidInterface")) {
      // 属性存在
      this.isAndroidWap = true;
  } else {
      this.isAndroidWap = false;

      // 属性不存在
  }
  }

  getMarksixSettings() {
    this.lotteryService.getSixSetting().then((settings) => {
      if (!settings) {
        return;
      }
      let year = Number(settings.LiuhecaiHXDate);
      AppConfig.markSixYear = year > 1900 ? year : new Date().getFullYear();
      AppConfig.markSixPrevYear = AppConfig.markSixYear - 1;
      this.storage.write("markSixInfo", settings);
    }).catch(() => {
      AppConfig.markSixYear = new Date().getFullYear();
      AppConfig.markSixPrevYear = AppConfig.markSixYear - 1;
    });
  }
  catchId = uuid();
  captchaSrc: string =
    AppConfig.GetProdUrl() + "/auth/ValidateCode?id=" + this.catchId;
  loginForm = this.formBuilder.group({
    UserName: [this.lastUser.username, [Validators.required]],
    Password: [this.lastUser.pwd, [Validators.required]],
    Captcha: "",
    remeberPwd: [false],
    ping: [this.autourl[0]],
  });

  kefuUrl = '';
  //用户名的blur事件
  usernameBlur() {
    if (this.users != null) {
      let curUser = this.users.find(
        (s) => s.username == this.loginForm.value.UserName
      );
      if (curUser) {
        this.lastUser.pwd = curUser.pwd;
      }
    }
  }
  ionViewWillEnter() {
    clearInterval(AppConfig.balanceTimer);
    this.register();
    this.getPlatformLineList();
    this.initScreen();
    this.sysconfig
      .getServiceUrl()
      .then((data) => {
        if (data) {
          this.kefuUrl = data.CustomerServiceUrl;
        }
      })
      .catch((err) => { });
  }
  ionViewDidLoad() {
    if (!AppConfig.GetHostUrl()) {
      let appload = this.loading.showLoding();
      this.sysconfig
        .GetPhoneSettings(null)
        .then((s: AppInfo) => {
          let u = navigator.userAgent;
          // 判断终端设备
          var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端
          var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          if (isAndroid) {
            AppConfig.downloadUrl = s.AndroidUrl;
            this.downloadUrl = s.AndroidUrl;
            // this.isWap = false;
          } else if (isiOS) {
            AppConfig.downloadUrl = s.IosUrl;
            this.downloadUrl = s.IosUrl;
            // this.isWap = false;
          }
          // else {
          //   this.isWap = true;
          // }
          this.loading.closeLoading(appload);
        })
        .catch((e) => {
          this.loading.closeLoading(appload);
        });
    }
  }

  refreshCode() {
    let count = this.sum_count;
    if (!this.captchaTimer) {
      this.captchaTimer = setInterval(() => {
        if (count > 1 && count <= this.sum_count) {
          count--;
        } else {
          clearInterval(this.captchaTimer);
          this.captchaTimer = null;
          this.refreshCaptcha();
        }
      }, 1000);
    }
  }
  refreshCaptcha() {
    this.catchId = uuid();
    this.captchaSrc = AppConfig.GetProdUrl() + "/auth/ValidateCode?id=" + this.catchId;
    // clearInterval(this.captchaTimer);
    // this.captchaTimer = null;
    // this.refreshCode();
  }

  login() {

    if (this.showZhongWen && this.validateStatus == false) {
      return this.alert.showAlert('请先进行验证，通过后在登录。')
    }
    if (this.loginNeedSecurityImage && this.loginSecurityImageResult == false) {
      return this.alert.showAlert('请先进行验证，通过后在登录。')
    }
    var user = {
      username: this.loginForm.value.UserName,
      password: this.loginForm.value.Password,
      captcha: this.loginForm.value.Captcha,
      captchaId: this.catchId,
    };
    let load = this.loading.showLoding("登录中...");
    this.signinService.login(user).then((data) => {
      if (data) {
        this.storage.writeString("token", data.access_token);
        this.getMarksixSettings();
        this.afkUrl();
        this.signinService.getUserModel().then((s) => {
          this.navCtrl.push(AgreeMsg, {
            user: s,
            token: data.access_token,
            users: {
              username: user.username,
              pwd: user.password,
              remeberpwd: this.loginForm.value.remeberPwd,
            },
          });
          this.storage.writeString(
            "userpwd",
            AppConfig.encodeBase64(this.loginForm.value.Password)
          );
          this.loading.closeLoading(load);
        })
          .catch(() => {
            this.loading.closeLoading(load);
          });
      } else {
        this.loginSecurityImageResult = false;
        this.loading.closeLoading(load);
        this.alert.showAlert(data.json().error_description);
      }
    })
      .catch((data) => {
        this.loading.closeLoading(load);
        if (data.json().error == 3) {
          this.showGoogleValidator(user);
        } else if (data.json().error == "5-2") {
          // this.alert.showAlert(data.json().error_description);
          this.refreshCaptcha();
          this.showZhongWen = true;

          this.alert.showAlert("点击进行验证！");
          // 验证失败
          this.validateStatus = false;
        } else if (data.json().error == "5-1") {
          this.loginSecurityImageResult = false;
          this.loginNeedSecurityImage = true;
          this.alert.showAlert(data.json().error_description);
        }
        else if (data.json().error == "96") {
          this.alert.showAlert(data.json().error_description);
          this.isShowQrCode = true;
        } else {
          this.loginSecurityImageResult = false;
          this.validateStatus = false;
          this.alert.showAlert(data.json().error_description);
        }
      });
  }

  /**
   * 是否需要滑块验证码
   */
  onLoginNeedSecurityImage() {
    const popover = this.popoverCtrl.create(slideBlockCommon, {}, { cssClass: "check-captcha-component" }
    );
    popover.present();
    popover.onDidDismiss((data: any) => {
      if (data && data.catchId && data.authSuccess) {
        this.loginSecurityImageResult = data.authSuccess;
        this.catchId = data.catchId;
      }
    });
  }

  private showGoogleValidator(user: any) {
    let prompt = this.alertCtrl.create({
      title: "谷歌登录器",
      message: "请输入动态验证码",
      inputs: [
        {
          name: "cknum",
          placeholder: "动态验证码",
        },
      ],
      buttons: [
        {
          text: "取消",
        },
        {
          text: "确认",
          handler: (data) => {
            var cknum: string = data.cknum;
            if (cknum == null || cknum.trim() == "") {
              this.alert.showAlert("请输入动态验证码");
            } else {
              var user = {
                username: this.loginForm.value.UserName,
                password: this.loginForm.value.Password,
                captcha: this.loginForm.value.Captcha,
                gasecret: cknum,
                captchaId: this.catchId,
              };
              let load = this.loading.showLoding("登录中...");
              this.signinService
                .login(user)
                .then((data) => {
                  this.storage.writeString("token", data.access_token);
                  this.getMarksixSettings();
                  this.signinService
                    .getUserModel()
                    .then((s) => {
                      this.storage.remove("token");
                      this.navCtrl.push(AgreeMsg, {
                        user: s,
                        token: data.access_token,
                        users: {
                          username: user.username,
                          pwd: user.password,
                          remeberpwd: this.loginForm.value.remeberPwd,
                        },
                      });
                      this.loading.closeLoading(load);
                    })
                    .catch(() => {
                      this.loading.closeLoading(load);
                    });
                })
                .catch((data) => {
                  this.loading.closeLoading(load);
                  if (data.json().error == 3) {
                    this.showGoogleValidator(user);
                  } else if (data.json().error == "5") {
                    this.alert.showAlert(data.json().error_description);
                    $("#imgcode").click();
                  } else {
                    this.alert.showAlert(data.json().error_description);
                  }
                });
            }
          },
        },
      ],
    });
    prompt.present();
  }
  /**
   *
   * 验证成功 登录密码还是错误的情况下
   * @param {*} val 执行后的返回结果
   * @memberof LoginComponent
   */
  validateStatusChange(val) {
    this.validateStatus = val;
  }

  getCaptchaId(Id) {
    this.catchId = Id;
  }
  download() {
    window.open(AppConfig.downloadUrl, "_system");
  }
  //在线客服
  //TQQ 2017-01-19
  customer() {
    this.config.openUrl(this.kefuUrl);
  }

  //PC浏览
  //chen 2017-03-15
  computer() {
    this.alert.showConfirm("切换流量模式", () => {
      this.config.openUrl("http://119.28.63.188:1000/login");
    });
  }

  //域名检测
  //chen 2017-03-15
  realm() {
    this.navCtrl.push(Realm);
  }

  // showCaptchaModal() {
  //   const model = this.modalCtrl.create(SliderCaptchaPage, {
  //     validateStatus: this.validateStatus,
  //   });
  //   model.present();
  //   model.onWillDismiss((data: any[]) => {
  //     console.log(data);

  //     if (data) {
  //       if (this.validateStatus == true) {
  //         this.showCaptcha = true;
  //       }
  //     }
  //   });
  // }

  // 获取是否开启挂机与地址、刷新挂机
  afkUrl() {
    this.sysconfig
      .getHangonTool()
      .then((s) => {
        if (s.Value) {
          this.storage.writeString("AfkURL", s.Data.toString().trim());
        } else {
          this.storage.remove("AfkURL");
        }
      })
      .catch((err) => {
        this.storage.remove("AfkURL");
      });
  }

  getPlatformLineList() {
    this.sysconfig.getPlatformLineList().then(res => {
      if (res) {
        res.forEach(item => {
          if (item.LineType == 3) {
            this.wapUrl.push(item);
          } else if (item.LineType == 6) {
            this.hijackingUrl = item.LineUrl
          }
        });
      }

    })
  }
  // 立即注册
  register() {
    this.signinService.register().then((s) => {
      this.storage.writeString("registerURL", s.RegisterUrl);
      if (s.Enable === true) {
        this.isEnable = true;

        let code = s.RegisterUrl.split('ey=')[1];
        let protocol = window.location.protocol;
        let host = window.location.host;
        this.link = protocol + '//' + host + "/?Key=" + code;

      } else if (s.Enable === false) {
        this.isEnable = false;
      }
    });
  }
  goRegisterURl() {
    this.iab.create(this.link, '_system');
    // },'温馨提示')
  }
  hijackingLink() {
    window.open('https://www.xb888888.com/domains?platform=xinbao3')
  }
  initScreen() {
    if ((window.navigator as any).standalone || false) {
      this.isAppScreen = true
    } else {
      this.isAppScreen = false;
    }
  }
  /**
 * 中文验证
 */
   onLoginChineseNeedSecurity() {
    const popover = this.popoverCtrl.create(SliderCaptchaPage, {}, { cssClass: "chinese-need-Security" }
    );
    popover.present();
    popover.onDidDismiss((data: any) => {
      console.log(data);
      if (data) {
        this.validateStatus = data.authSuccess;
        this.catchId = data.catchId;
        // this.code = data.code
      }

    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/signin/signin.ts